import React, { useState } from 'react';
import { Box, Grid, Button, TextField, Card, CardContent, Typography, IconButton, Input, Paper } from '@mui/material';
import { Folder as FolderIcon, FileOpen, Delete, LibraryBooks, Article } from '@mui/icons-material';

interface FolderType {
  name: string;
  lastModified?: string;
  size?: string;
  onClickFunc: (name: string) => void;
  view?: 'grid' | 'list';
}

const Folder: React.FC<FolderType> = ({
    name,
    lastModified = '-------------------------',
    size = '-----------------------',
    onClickFunc,
    view = 'list'
}) => {
return (
    <>
        <Paper elevation={3} sx={{mt: 2, padding: 2, borderRadius: 3, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}} onClick={() => onClickFunc(name)}>
            <Box color={'text.secondary'} sx={{p: 0.5,  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                <FolderIcon />
                <Typography sx={{ml:2.5}} alignSelf='center' variant="body1" color="textSecondary">{name}</Typography>
            </Box>
            <Typography alignSelf='center' variant="body1" color="textSecondary">{lastModified}</Typography>
            <Typography alignSelf='center' variant="body1" color="textSecondary">{size}</Typography>
        </Paper>
    </>
)

};

export default Folder;
